import { Controller } from "stimulus"
import $ from "jquery"
// CSS is imported in application.js pack for better production compatibility
import "summernote/dist/summernote-lite.js"

export default class extends Controller {
  connect() {
    console.log('Summernote controller connected')

    // Find the textarea using querySelector instead of targets
    const editorElement = this.element.querySelector('[data-summernote-target="editor"]')

    if (!editorElement) {
      console.error('Summernote editor element not found')
      return
    }

    // Store reference
    this.editorElement = editorElement

    // Expose controller instance on the element for external access
    this.element.summernoteController = this

    // Initialize Summernote on the textarea
    $(editorElement).summernote({
      height: 400,
      minHeight: 300,
      maxHeight: 600,
      placeholder: editorElement.dataset.placeholder || 'Compose your email...',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'italic', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
        ['table', ['table']],
        ['insert', ['link', 'picture']],
        ['view', ['fullscreen', 'codeview', 'help']]
      ],
      styleTags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
      fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'ui-sans-serif'],
      fontNamesIgnoreCheck: ['Arial', 'Helvetica', 'Verdana'],
      callbacks: {
        onChange: (contents) => {
          // Update the textarea value when content changes
          $(editorElement).val(contents)
        },
        // Editing in code view fires `change.codeview`, not `change`, so
        // Summernote's own AutoSync never touches the textarea. Without this
        // the form submits the stale WYSIWYG value and the edit is lost.
        onChangeCodeview: (contents) => {
          $(editorElement).val(contents)
        }
      }
    })

    // Safety net: whatever mode the editor is in, push the live content into
    // the textarea right before the form serializes it.
    this.form = this.element.closest('form')
    if (this.form) {
      this.syncBeforeSubmit = () => this.sync()
      this.form.addEventListener('submit', this.syncBeforeSubmit)
    }

    console.log('Summernote initialized successfully')
  }

  // Copy the editor's current content (WYSIWYG or code view) into the textarea.
  sync() {
    if (this.editorElement && $(this.editorElement).data('summernote')) {
      $(this.editorElement).val($(this.editorElement).summernote('code'))
    }
  }

  // Method to set content programmatically (for AI improvements)
  setContent(html) {
    if (this.editorElement) {
      $(this.editorElement).summernote('code', html)
    }
  }

  // Method to get content
  getContent() {
    if (this.editorElement) {
      return $(this.editorElement).summernote('code')
    }
    return ''
  }

  disconnect() {
    if (this.form && this.syncBeforeSubmit) {
      this.form.removeEventListener('submit', this.syncBeforeSubmit)
    }
    if (this.editorElement && $(this.editorElement).data('summernote')) {
      $(this.editorElement).summernote('destroy')
    }
  }
}
